import 'css-chunksrc/client/scenes/projectPortfolioCreation/form/styles.scss';export default {
  "form": "_form_hrvta_1",
  "group": "_group_hrvta_5",
  "label": "_label_hrvta_9",
  "row": "_row_hrvta_15",
  "textInput": "_textInput_hrvta_23",
  "tag": "_tag_hrvta_27",
  "description": "_description_hrvta_31"
};